import React, { useState } from 'react'
import { Modal, Radio } from 'antd'
import { Button } from 'components/Button'
import { Heading } from 'components/Typography'
import { ExclamationCircleOutlined } from '@ant-design/icons'

const StdRegistrationRequest = ({ open, onClose, updateRegistrationSettings, getDashboard, params, togglePageLoader, dashboardDetails }) => {

        // const [autoApproval, setAutoApproval] = useState(false);
        const [loader, setLoader] = useState(false);

        const callback = () => {
                setLoader(false);
                onClose()
                togglePageLoader(true);
                getDashboard(params, () => togglePageLoader(false))
        }

        const handleUpdateSetting = () => {
                let params = {
                        studentAutoApproved: true
                }
                setLoader(true)
                updateRegistrationSettings(params, () => callback());
        };

        return (
                <Modal
                        centered
                        closable
                        open={open}
                        footer={null}
                        className='modal-round-corner'
                        onCancel={onClose}
                >
                        <center style={{ padding: 20 }}>
                                <center><Heading>Student’s registration request</Heading></center>
                                <center style={{ color: '#636363', fontWeight: 600, fontSize: 14 }}>Enable student’s registration request to be auto/manually approved.</center>
                                <div style={{ display: 'flex', alignContent: 'flex-start' }}>
                                        <Radio.Group defaultValue={dashboardDetails?.studentAutoApproved} onChange={(e) => setAutoApproval(e.target.value)}>
                                                <div className='flex-column m-t-20'>
                                                        <Radio value={true}><div style={{ marginLeft: 10, color: '#191919', fontWeight: 600, width: 'fit-content' }}>Auto approval</div></Radio>
                                                        <Radio value={false}><div style={{ marginLeft: 10, color: '#191919', fontWeight: 600, width: 'fit-content' }}>Manual approval</div></Radio>
                                                </div>
                                        </Radio.Group>
                                </div>
                                <div className='r-c-c m-t-20'>
                                        <ExclamationCircleOutlined style={{ color: '#1089FF' }} />
                                        <div style={{ color: '#636363', fontSize: 14, fontWeight: 500 }}>Kindly note that for teachers, data operators and operations registration request will remain a manual approval process.</div>
                                </div>
                                <Button type='primary' style={{ marginTop: 30 }} loading={loader} onClick={() => { handleUpdateSetting() }}>UPDATE</Button>
                        </center>
                </Modal>
        )
}

export default StdRegistrationRequest;